import { TipsIcon } from '@tlx/atlas';
import React from 'react';

export function SalaryOnboardingTips({
    tag,
    children,
    title,
}: {
    tag: string;
    children: React.ReactNode;
    title: string;
}) {
    return (
        <div className="atl-border atl-rounded atl-border-blue-40 atl-bg-blue-5 atl-p-16">
            <div className="atl-bg-blue-10 atl-inline-flex atl-px-12 atl-flex atl-justify-center atl-items-center atl-gap-4 atl-rounded-full">
                <TipsIcon size="small" className="atl-text-blue-100" />
                {tag}
            </div>
            <div className="atl-text-lg atl-font-medium atl-my-8">{title}</div>
            {children}
        </div>
    );
}
